var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('s-modal-container'),_c('s-copy'),_c('s-confirm'),_c('s-notification-container',{attrs:{"top":"50px","right":"50px"}}),(_vm.ready)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }